// src/components/Admin/StoreManager/index.jsx
import { Tabs, Tab, Box, Typography, Paper, useTheme, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import EmoticonManager from '../EmoticonManager';
import ItemManager from '../ItemManager';
import MiniroomManager from '../MiniroomManager';

import StorefrontIcon from '@mui/icons-material/Storefront';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import ChairIcon from '@mui/icons-material/Chair';

const StoreManager = () => {
    const [tab, setTab] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box sx={{ p: isMobile ? 2 : 4, width: '100%', maxWidth: '100%' }}>
            {/* 타이틀 */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                <StorefrontIcon sx={{ fontSize: '2rem' }} />
                <Typography variant={isMobile ? 'h6' : 'h4'} sx={{ fontWeight: 'bold' }}>
                    상점 관리
                </Typography>
            </Box>

            {/* 탭 메뉴 */}
            <Paper
                elevation={2}
                sx={{
                    mb: 3,
                    borderRadius: 2,
                    backgroundColor: '#f5f5f5',
                    px: isMobile ? 1 : 2,
                    overflowX: 'auto', // ✅ 탭만 스크롤 가능
                }}
            >
                <Tabs
                    value={tab}
                    onChange={(_, v) => setTab(v)}
                    textColor="primary"
                    indicatorColor="primary"
                    variant={isMobile ? 'scrollable' : 'fullWidth'}
                    scrollButtons={isMobile}
                    allowScrollButtonsMobile
                    sx={{
                        minHeight: 44,
                        '& .MuiTab-root': {
                            minHeight: 44,
                            whiteSpace: 'nowrap',
                            fontSize: isMobile ? '0.85rem' : '1rem',
                            minWidth: isMobile ? 140 : 'auto',
                            px: isMobile ? 1 : 2,
                        },
                    }}
                >
                    <Tab icon={<CardGiftcardIcon />} iconPosition="start" label="쿠폰 관리" />
                    <Tab icon={<EmojiEmotionsIcon />} iconPosition="start" label="이모티콘 관리" />
                    <Tab icon={<ChairIcon />} iconPosition="start" label="미니룸 가구 관리" />
                </Tabs>
            </Paper>

            {/* 콘텐츠 */}
            {tab === 0 && <ItemManager />}
            {tab === 1 && <EmoticonManager />}
            {tab === 2 && <MiniroomManager />}
        </Box>
    );
};

export default StoreManager;
